module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "font-weight-bold darkgrey--text",
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$attrs.detail.intrepretation_id ? "Ubah" : "Tambah") + " Jenis\n        Interpretasi\n    ")]), _vm._v(" "), _c('v-card', {
    staticClass: "mx-5 my-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 black60--text pb-2",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                    Judul\n                ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "placeholder": "Judul",
      "items": _vm.list_potential,
      "item-text": "name",
      "item-value": "id",
      "outlined": ""
    },
    model: {
      value: (_vm.data.title),
      callback: function($$v) {
        _vm.$set(_vm.data, "title", $$v)
      },
      expression: "data.title"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-row', {
    staticStyle: {
      "align-items": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-flex justify-center",
    attrs: {
      "cols": "4"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    key: _vm.keyimg,
    attrs: {
      "src": _vm.url ?
        _vm.url :
        _vm.data.image && _vm.data.image != '' ?
        _vm.data.image :
        require('@/assets/img/unavailable.png')
    }
  })])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    staticClass: "font-weight-bold blew--text",
    attrs: {
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.$refs.uploader.click()
      }
    }
  }, [_vm._v("\n                            Upload Foto\n                        ")]), _vm._v(" "), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "id": "photo_tema_skala",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-3 grey--text",
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("\n                            Rasio thumbnail Icon 1:1 (HD)\n                        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-500 black60--text",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                    Deskripsi\n                ")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('app-editor', {
    attrs: {
      "value": _vm.data.description,
      "hasUpload": false,
      "title": 'Deskripsi'
    },
    on: {
      "content-updated": function($event) {
        _vm.data.description = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pb-5"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(" Tutup ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "dark": "",
      "depressed": "",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.upload()
      }
    }
  }, [_vm._v("\n            Simpan\n        ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24f45582","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_test/components/DialogInterpretasi.vue
// module id = 1470
// module chunks = 1